import React, { Component } from "react";
import RealTimeService from "../apiservices/RealtimeService";
import {
  Dropdown,
  Divider,
  Box,
  Avatar,
  Button,
  Table,
} from "@fluentui/react-northstar";
import { alpha, styled } from "@mui/material/styles";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Icon } from "@fluentui/react/lib/Icon";
import TextField from "@mui/material/TextField";
import axios from "axios";
import "./realtime.css";
import { Link } from "react-router-dom";
import RealtimeGroupChart from "./realtimeGroupChart";
import { ThemeProvider } from "@mui/material";
import TagsService from "../apiservices/TagsService";
import Timer from "react-timer-wrapper";
import Timecode from "react-timecode";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#8764b8",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#8764b8",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#5c2e91",
    },
    "&:hover fieldset": {
      borderColor: "#8764b8",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#8764b8",
    },
  },
});

const timer = {
  content: (
    <Timer>
      <Timecode></Timecode>
    </Timer>
  ),
};
initializeIcons();

export default class Realtime extends Component {
  constructor(props) {
    super(props);

    this.getGroups = this.getGroups.bind(this);
    this.getTags = this.getTags.bind(this);
    this.handleOnSelectedGroup = this.handleOnSelectedGroup.bind(this);
    this.handleOnSelectedTags = this.handleOnSelectedTags.bind(this);

    this.state = {
      userId: "",
      groups: [],
      tags: [],
      isSelectedGroup: false,
      groupSelected: "",
      isSelectedTags: false,
      tagsSelected: [],
      isQueueRealtimeSelected: true,
      agents: [],
      agentsCopy: [],
      queueSelectedData: "",
      filterAgentApplied: false,
      queueSelectedCallsOnHoldDetail: [],
      headerCallsOnQueue: {
        items: ["Number", "Waiting Time"],
      },
      rowsCallsDetailed: [
        {
          key: 1,
          items: [
            "621244421",
            <Timer active duration={null}>
              <Timecode />
            </Timer>,
          ],
        },
        {
          key: 2,
          items: [
            "657764558",
            <Timer active duration={null}>
              <Timecode />
            </Timer>,
          ],
        },
      ],
    };
  }

  handleChange(e) {
    if (e.target.value.length >= 1) {
      this.setState({ filterAgentApplied: true });
    }
    if (e.target.value.length === 0) {
      this.setState({ filterAgentApplied: false });
    }
    const agentsToFind = this.state.agentsCopy;
    const foundAgents = agentsToFind.filter((x) =>
      x.name.toLowerCase().includes(e.target.value)
    );
    this.setState({ agents: foundAgents });
  }

  componentDidMount() {
    const krakenCalls = sessionStorage.getItem("krakenCalls");
    const username = sessionStorage.getItem("userName");
    if (username === "nacho@qcompusoft.com") {
      this.setState({
        tagsSelected: ["WinVet_Tecnico"],
        isQueueRealtimeSelected: false,
      });
    }
    setInterval(() => {
      const username = sessionStorage.getItem("userName");
      this.updateAgentStatus();

      if (username === "nacho@qcompusoft.com") {
        this.updateCallsOnQueue();
        this.getGroupSelectedStats("WinVet_Tecnico");
      }
    }, 2000);

    this.setState({ krakenC: krakenCalls === "true" ? true : false });
    this.getGroups(username);
    this.getTags(username);
  }

  spyClicked(channel) {
    const extension = sessionStorage.getItem("extension");
    const company = sessionStorage.getItem("company");

    RealTimeService.postSpyCall(channel, extension, company, extension)
      .then((response) => {})
      .catch((e) => {
        console.log(e);
      });
  }
  updateCallsOnQueue() {
    if (this.state.queueSelectedData.queueOnHoldList) {
      if (
        this.state.queueSelectedData.queueOnHoldList !==
        this.state.queueSelectedCallsOnHoldDetail
      ) {
        const newArray = [];
        for (let number of this.state.queueSelectedCallsOnHoldDetail) {
          const time1 = new Date();
          const time2 = time1.getTime();

          newArray.push({
            key: parseInt(number),
            items: [
              number.number,
              <Timer time={time2 - number.timeStarted} active duration={null}>
                <Timecode />
              </Timer>,
            ],
          });
        }
        this.setState({
          rowsCallsDetailed: newArray,
          queueSelectedCallsOnHoldDetail:
            this.state.queueSelectedData.queueOnHoldList,
        });
      }
    }
  }

  updateAgentStatus() {
    if (this.state.filterApplied && this.state.agents !== []) {
      const username = sessionStorage.getItem("userName");
      const pToken = sessionStorage.getItem("pToken");
      let agentsArray = [];
      for (let agents of this.state.agentsCopy) {
        agentsArray.push(agents.teamsId);
      }

      RealTimeService.getAllAgentsStatus(agentsArray, pToken)
        .then((response) => {
          let agentsStatuss = this.state.agents;
          for (let user of response.data) {
            agentsStatuss = agentsStatuss.map((obj) => {
              if (obj.teamsId === user.user.id) {
                return {
                  ...obj,
                  status: user.user.status,
                  statusInfo: user.user.statusInfo,
                  callStatus: user.callStatus,
                };
              }
              return obj;
            });
          }
          this.setState({ agents: agentsStatuss });
          if (!this.state.filterAgentApplied) {
            this.setState({ agentsCopy: agentsStatuss });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
    }
  }

  getGroups() {
    const username = sessionStorage.getItem("userName");
    RealTimeService.getGroups(username)
      .then((response) => {
        this.setState({
          groups: response.data,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getTags() {
    const username = sessionStorage.getItem("userName");
    TagsService.getGroups(username)
      .then((response) => {
        this.setState({
          tags: response.data,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getTimer(time) {
    const time1 = new Date();
    const time2 = time1.getTime();
    const time3 = time2 - time;
    return time3;
  }

  handleOnSelectedGroup(selectedGroup) {
    this.setState({
      groupSelected: selectedGroup,
    });
    this.getGroupSelectedStats(selectedGroup);
    this.getAgents(selectedGroup);
  }

  handleOnSelectedTags(item) {
    this.setState({
      tagsSelected: [...this.state.tagsSelected, item],
    });
  }

  handleOnSelectedTagsRemoved(item) {
    const remainingArr = this.state.tagsSelected.filter(
      (data) => data !== item
    );
    this.setState({ tagsSelected: remainingArr });
  }

  getToken() {
    const tokenString = sessionStorage.getItem("tokenStats");
    return tokenString;
  }
  getUsername() {
    const tokenString = sessionStorage.getItem("userName");
    return tokenString;
  }
  getGroupSelectedStats(selectedGroup) {
    const token = this.getToken();
    const username = this.getUsername();
    const company = sessionStorage.getItem("company");

    RealTimeService.getRealtimeGroupSelected(
      selectedGroup,
      token,
      username,
      company
    )
      .then((response) => {
        console.log(response.data);
        this.setState({
          queueSelectedData: response.data[0],
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getAgents(groupName) {
    let newAgents = [];
    const pToken = sessionStorage.getItem("pToken");
    const userName = sessionStorage.getItem("userName");
    RealTimeService.getAgents(groupName, userName)
      .then((response) => {
        for (let agent of response.data) {
          axios
            .get(
              `https://graph.microsoft.com/v1.0/users/${agent.agentId}/photo/$value`,
              {
                headers: {
                  Authorization: `Bearer ${pToken}`,
                },
                responseType: "blob",
              }
            )
            .then((o) => {
              const url = window.URL || window.webkitURL;
              const blobUrl = url.createObjectURL(o.data);
              const agentObject = {
                ...agent,
                photo: blobUrl,
              };
              newAgents.push(agentObject);
            })
            .catch((e) => {
              newAgents.push(agent);
              console.log(e);
            });
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      this.setState({ agents: newAgents });
      this.setState({ agentsCopy: newAgents });
    }, 2000);
  }

  setImg(img) {
    if (img === "En una reunión") {
      return "#A80000";
    }
    if (img === "Disponible") {
      return "#237B4B";
    }
    if (img === "Ocupado") {
      return "#A80000";
    }
  }

  getIcon(direction) {
    if (direction === "INTERNAL") {
      return "BackToWindow";
    }
    if (direction === "Saliente") {
      return "ArrowUpRight8";
    }
    if (direction === "Entrante") {
      return "ArrowDownRight8";
    }
  }

  getQueueDataRealtimeSelected() {
    const data = [
      {
        name: "Attended",
        value: this.state.queueSelectedData.Atendidas,
      },
      {
        name: "Non-Attended",
        value: this.state.queueSelectedData["No Atendidas"],
      },
      {
        name: "Abandon",
        value: this.state.queueSelectedData.Abandonadas,
      },
    ];
    return data;
  }

  setApplyFIlters = async () => {
    this.setState({ isLoading: true });
    for (let queue of this.state.tagsSelected) {
      const result = queue.replace("#", "%23");
      const result2 = await this.getAgents(result);
      this.setState(result2);
    }
    setTimeout(() => {
      this.setState({ isLoading: false });
      this.setState({ filterApplied: true });
    }, 3000);
  };

  render() {
    return (
      <>
        <div className="realtimeBody">
          <h1 className="h1">Realtime</h1>
          <div style={{ display: "flex" }}>
            {/* <div>
              Select entry Group (optional) <br></br>
              <br></br>
              <div>
                <Dropdown
                  items={this.state.groups}
                  checkable
                  placeholder="Select a group"
                  getA11ySelectionMessage={{
                    onAdd: (item) => this.handleOnSelectedGroup(item),
                  }}
                />
              </div>
            </div> */}
            <div>{"   "}</div>
            {"   "}
            <div style={{ marginLeft: "10px" }}>
              <h4>
                <Icon iconName="Tag" /> Select TAGS (Agents)
              </h4>

              <div
                style={{
                  marginTop: -5,
                }}
              >
                <Dropdown
                  multiple
                  items={this.state.tags}
                  checkable
                  getA11ySelectionMessage={{
                    onAdd: (item) => this.handleOnSelectedTags(item),
                    onRemove: (item) => this.handleOnSelectedTagsRemoved(item),
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: 10,
              marginLeft: 10,
              display: "flex",
            }}
          >
            <Button
              onClick={() => {
                this.setApplyFIlters();
              }}
              loading={this.state.isLoading}
              primary
              content={
                this.state.isLoading ? "Applying Filters" : "Apply filters"
              }
            />
            <div style={{ marginTop: 10 }}>{"  "}</div>
            <Link
              to="/realtime-manage-groups"
              style={{ textDecoration: "none" }}
            >
              {/* <Button content="Edit Groups" /> */}
            </Link>
            <div
              style={{
                float: "right",
                marginLeft: "auto",
                width: 300,
                marginBottom: 15,
                position: "relative",
              }}
            >
              {" "}
              <CssTextField
                label="Search agent"
                size="small"
                onChange={(e) => this.handleChange(e)}
                id="custom-css-outlined-input"
              />
            </div>
          </div>

          <div>
            <Divider />
          </div>
          {this.state.filterApplied ? (
            <div className="realtimeBoxBody">
              <div className="agents">
                {this.state.agents.map(
                  ({
                    index,
                    name,
                    status,
                    photo,
                    statusInfo,
                    llamadaInfo,
                    callStatus,
                    extension,
                  }) => (
                    <div className="box">
                      <Box
                        content="Box"
                        styles={{
                          border: "3px solid #ccc",
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          borderBottomRightRadius: "10px",
                          color: "black",
                          textAlign: "Left",
                          width: "900px",
                          height: "215px",
                        }}
                      >
                        <div className="boxContent">
                          <h2 className="agentName">{name}</h2>
                          <b>Status:</b> {statusInfo}{" "}
                          {callStatus.estado === "En curso" &&
                          this.state.krakenC ? (
                            <div
                              style={{
                                marginLeft: -50,
                                marginRight: 10,
                                float: "right",
                              }}
                            >
                              <Button
                                style={{ marginTop: -10 }}
                                loading={true}
                                title="Spy Call"
                                size="small"
                                onClick={() => {
                                  this.spyClicked(callStatus.channel);
                                }}
                              >
                                <Icon iconName="HeadsetSolid" />
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          <br></br>
                          <div className="dividerBox">
                            <Divider />
                          </div>
                          <div className="divContentBox">
                            {callStatus.direction ? (
                              <div style={{ height: 20.4 }}>
                                <Icon
                                  iconName={this.getIcon(callStatus.direction)}
                                />
                                {" : "}
                                {callStatus.direction}
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}

                            {callStatus.direction ? (
                              <div className="timer" style={{ height: 20.4 }}>
                                <Icon iconName="Timer" />
                                <div style={{ marginLeft: 3 }}>{"  :  "}</div>
                                <div style={{ marginLeft: 3 }}>
                                  {callStatus.timeStarted ? (
                                    <Timer
                                      time={this.getTimer(
                                        callStatus.timeStarted
                                      )}
                                      active
                                      duration={null}
                                    >
                                      <Timecode />
                                    </Timer>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}
                            {callStatus.estado ? (
                              <div style={{ height: 20.4 }}>
                                <Icon iconName="SyncStatusSolid" />
                                {" : "}
                                {callStatus.estado}
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}
                            {callStatus.destino ? (
                              <div style={{ height: 20.4 }}>
                                <Icon iconName="Phone" />
                                {"  :  "}
                                {callStatus.destino}
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}

                            {callStatus.cola ? (
                              <div style={{ height: 20.4 }}>
                                <Icon iconName="Group" />
                                {"  :  "}
                                {callStatus.cola}
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}
                            {callStatus.ddi ? (
                              <div style={{ height: 20.4 }}>
                                <Icon iconName="NumberSymbol" />
                                {"  :  "}
                                {callStatus.ddi}
                              </div>
                            ) : (
                              <div style={{ height: 20.4 }}>
                                <br></br>
                              </div>
                            )}
                          </div>
                          <div className="statusAndPhoto">
                            <div className="status">
                              <div className="statusInfo"></div>
                            </div>
                            <div
                              class="circle"
                              style={{
                                backgroundColor: `${status}`,
                                width: "75px",
                                height: "75px",
                                borderRadius: "75px",
                                marginLeft: "140px",
                                position: "relative",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: "7.3%",
                                  top: "7.5%",
                                }}
                              >
                                <Avatar
                                  name={name}
                                  image={photo}
                                  size="larger"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Box>
                    </div>
                  )
                )}
              </div>
              {this.state.isQueueRealtimeSelected ? (
                <div
                  style={{
                    marginLeft: "-30%",
                  }}
                ></div>
              ) : (
                <>
                  <div>
                    <Divider vertical />
                  </div>
                  <div className="groups">
                    <div className="groupsTittle">
                      <h1>Groups - Daily stats</h1>
                    </div>
                    <div className="selectedGroups">
                      <b>QCompusoft</b> {this.state.groupSelected}
                    </div>
                    <div className="onQueueCalls">
                      <div>
                        <b>
                          <Icon iconName="IncomingCall" /> Incoming calls:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData.queueOnHold}
                      </div>
                      <Divider />
                    </div>
                    <div className="otherStats">
                      <div>
                        <b>
                          <Icon iconName="UserFollowed" /> Attended:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData.Atendidas}
                      </div>
                      <Divider />
                    </div>

                    <div className="otherStats">
                      <div>
                        <b>
                          <Icon iconName="UserRemove" /> Non-Attended:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData["No Atendidas"]}
                      </div>
                      <Divider />
                    </div>
                    <div className="otherStats">
                      <div>
                        <b>
                          <Icon iconName="TemporaryUser" size="40px" />{" "}
                          Abandoned:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData.Abandonadas}
                      </div>
                      <Divider />
                    </div>
                    <div className="otherStats">
                      <div>
                        <b>
                          <Icon iconName="TimePicker" /> Av. Time:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData["Call Time"]}
                      </div>
                      <Divider />
                    </div>
                    <div className="otherStats">
                      <div>
                        <b>
                          <Icon iconName="Timer" /> Av. Wait:{" "}
                        </b>{" "}
                        {this.state.queueSelectedData["Hold Time"]}
                      </div>
                      <Divider />
                    </div>
                    <RealtimeGroupChart
                      data={this.getQueueDataRealtimeSelected()}
                    />

                    <div className="onQueueCallsList">
                      {" "}
                      <Divider />
                      <Table
                        compact
                        header={this.state.headerCallsOnQueue}
                        rows={this.state.rowsCallsDetailed}
                        aria-label="Compact view static table"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}
